import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';
import { pullWishlistFromBackend } from './wishlist';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [type, setType] = useState(null); // customer | admin
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem('io_token');
        if (!token) { setUser(null); setType(null); setLoading(false); return; }
        try {
            const { data } = await api.get('/auth/me');
            if (data.type === 'customer') { setUser(data.customer); setType('customer'); pullWishlistFromBackend(); }
            else if (data.type === 'admin') { setUser(data.admin); setType('admin'); }
            else if (data.type === 'brand') { setUser({ ...data.user, brand: data.brand }); setType('brand'); }
        } catch (e) {
            localStorage.removeItem('io_token'); setUser(null); setType(null);
        } finally { setLoading(false); }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const loginCustomer = async (email, password) => {
        const { data } = await api.post('/auth/customer/login', { email, password });
        localStorage.setItem('io_token', data.token);
        setUser(data.customer); setType('customer');
        pullWishlistFromBackend();
        return data.customer;
    };

    const registerCustomer = async (payload) => {
        const { data } = await api.post('/auth/customer/register', payload);
        localStorage.setItem('io_token', data.token);
        setUser(data.customer); setType('customer');
        pullWishlistFromBackend();
        return data.customer;
    };

    const loginAdmin = async (email, password) => {
        const { data } = await api.post('/auth/admin/login', { email, password });
        localStorage.setItem('io_token', data.token);
        setUser(data.admin); setType('admin');
        return data.admin;
    };

    const loginBrand = async (email, password) => {
        const { data } = await api.post('/auth/brand/login', { email, password });
        localStorage.setItem('io_token', data.token);
        setUser({ ...data.user, brand: data.brand }); setType('brand');
        return data;
    };

    const logout = () => {
        localStorage.removeItem('io_token');
        setUser(null); setType(null);
    };

    return (
        <AuthCtx.Provider value={{ user, type, loading, loginCustomer, registerCustomer, loginAdmin, loginBrand, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
